"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RecoverOrderColumnMigration", {
    enumerable: true,
    get: function() {
        return RecoverOrderColumnMigration;
    }
});
const _common = require("@nestjs/common");
const _pqueue = /*#__PURE__*/ _interop_require_default(require("p-queue"));
const _nc_job_005_order_column = require("./nc_job_005_order_column");
const _utils = require("~/utils");
const _globals = require("~/utils/globals");
const _models = require("~/models");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _cache = /*#__PURE__*/ _interop_require_default(require("~/utils/cache"));
const _Upgrader = /*#__PURE__*/ _interop_require_default(require("~/Upgrader"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const PARALLEL_LIMIT = +process.env.NC_ORDER_MIGRATION_PARALLEL_LIMIT || 10;
const dropColumnSql = {
    mysql2: 'ALTER TABLE ?? DROP COLUMN ??',
    mysql: 'ALTER TABLE ?? DROP COLUMN ??',
    pg: 'ALTER TABLE ?? DROP COLUMN ?? CASCADE',
    sqlite3: 'ALTER TABLE ?? DROP COLUMN ??'
};
let RecoverOrderColumnMigration = class RecoverOrderColumnMigration {
    logExecutionTime(message, hrTime) {
        const [seconds, nanoseconds] = process.hrtime(hrTime);
        // reset hrTime
        hrTime = process.hrtime();
        const elapsedSeconds = seconds + nanoseconds / 1e9;
        this.log(`${message} in ${elapsedSeconds}s`);
    }
    async job() {
        const ncMeta = new _Upgrader.default();
        try {
            var _this;
            this.cache.clear();
            ncMeta.enableUpgraderMode();
            const totalHrTime = process.hrtime();
            const numberOfModelsToBeProcessed = +((_this = await ncMeta.knexConnection(_globals.MetaTable.MODELS).join(_globals.MetaTable.SOURCES, `${_globals.MetaTable.MODELS}.source_id`, '=', `${_globals.MetaTable.SOURCES}.id`).where(`${_globals.MetaTable.MODELS}.mm`, false).where((builder)=>{
                builder.where(`${_globals.MetaTable.SOURCES}.is_meta`, true);
                builder.orWhere({
                    is_local: true
                });
            }).where((builder)=>{
                builder.where(`${_globals.MetaTable.MODELS}.deleted`, false).orWhereNull(`${_globals.MetaTable.MODELS}.deleted`);
            }).where((builder)=>{
                builder.whereNotExists(function() {
                    this.select(1).from(_globals.MetaTable.COLUMNS).whereRaw(`${_globals.MetaTable.COLUMNS}.fk_model_id = ${_globals.MetaTable.MODELS}.id`).where(`${_globals.MetaTable.COLUMNS}.uidt`, 'Order');
                }).orWhereExists(function() {
                    this.select(1).from(_globals.MetaTable.COLUMNS).whereRaw(`${_globals.MetaTable.COLUMNS}.fk_model_id = ${_globals.MetaTable.MODELS}.id`).where(`${_globals.MetaTable.COLUMNS}.uidt`, 'Decimal').where(`${_globals.MetaTable.COLUMNS}.system`, true).where(`${_globals.MetaTable.COLUMNS}.column_name`, '=', 'nc_order');
                });
            }).count('*', {
                as: 'count'
            }).first()) == null ? void 0 : _this.count);
            this.log(`Total models to be processed: ${numberOfModelsToBeProcessed}`);
            const queue = new _pqueue.default({
                concurrency: PARALLEL_LIMIT
            });
            // eslint-disable-next-line no-constant-condition
            while(true){
                if (queue.pending > PARALLEL_LIMIT * 2) {
                    await new Promise((resolve)=>setTimeout(resolve, 1000));
                    continue;
                }
                this.processingModels = this.processingModels.filter((m)=>m.processing);
                const models = await ncMeta.knexConnection(_globals.MetaTable.MODELS).select([
                    `${_globals.MetaTable.MODELS}.id`,
                    `${_globals.MetaTable.MODELS}.source_id`,
                    `${_globals.MetaTable.MODELS}.table_name`,
                    `${_globals.MetaTable.MODELS}.base_id`,
                    ..._utils.isEE ? [
                        `${_globals.MetaTable.MODELS}.fk_workspace_id`
                    ] : []
                ]).join(_globals.MetaTable.SOURCES, `${_globals.MetaTable.MODELS}.source_id`, '=', `${_globals.MetaTable.SOURCES}.id`).where(`${_globals.MetaTable.MODELS}.mm`, false).where((builder)=>{
                    builder.where(`${_globals.MetaTable.SOURCES}.is_meta`, true);
                    builder.orWhere({
                        is_local: true
                    });
                }).where((builder)=>{
                    builder.where(`${_globals.MetaTable.MODELS}.deleted`, false).orWhereNull(`${_globals.MetaTable.MODELS}.deleted`);
                }).whereNotIn(`${_globals.MetaTable.MODELS}.id`, this.processingModels.map((m)=>m.fk_model_id)).where((builder)=>{
                    builder.whereNotExists(function() {
                        this.select(1).from(_globals.MetaTable.COLUMNS).whereRaw(`${_globals.MetaTable.COLUMNS}.fk_model_id = ${_globals.MetaTable.MODELS}.id`).where(`${_globals.MetaTable.COLUMNS}.uidt`, 'Order');
                    }).orWhereExists(function() {
                        this.select(1).from(_globals.MetaTable.COLUMNS).whereRaw(`${_globals.MetaTable.COLUMNS}.fk_model_id = ${_globals.MetaTable.MODELS}.id`).where(`${_globals.MetaTable.COLUMNS}.uidt`, 'Decimal').where(`${_globals.MetaTable.COLUMNS}.system`, true).where(`${_globals.MetaTable.COLUMNS}.column_name`, '=', 'nc_order');
                    });
                }).limit(PARALLEL_LIMIT * 2);
                if (!(models == null ? void 0 : models.length)) break;
                for (const model of models){
                    this.processingModels.push({
                        fk_model_id: model.id,
                        processing: true
                    });
                    queue.add(()=>this.processModel(model, ncMeta)).catch((e)=>{
                        this.log(`Error processing model ${model.id}:`, e.message);
                    });
                }
            }
            await queue.onIdle();
            await ncMeta.disableUpgraderMode();
            this.log(`Migration completed. Processed ${this.processedModelsCount} models`);
            this.logExecutionTime('Migration job completed', totalHrTime);
            return await this.orderColumnMigration.job();
        } catch (error) {
            this.log('Migration failed:');
            console.error(error);
            await ncMeta.disableUpgraderMode();
            return false;
        }
    }
    async processModel(modelData, ncMeta) {
        try {
            const context = {
                base_id: modelData.base_id,
                workspace_id: modelData.fk_workspace_id
            };
            const originalSource = await this.cache.get(modelData.source_id, async ()=>_models.Source.get(context, modelData.source_id));
            if (!originalSource || !originalSource.isMeta()) {
                return;
            }
            const source = new _models.Source(_extends({}, originalSource, {
                upgraderMode: true,
                upgraderQueries: []
            }));
            const dbDriver = await _NcConnectionMgrv2.default.get(source);
            const model = await _models.Model.get(context, modelData.id);
            const baseModel = await _models.Model.getBaseModelSQL(context, {
                model,
                source,
                dbDriver
            });
            const tnPath = baseModel.getTnPath(model.table_name);
            const query = dbDriver.raw(dropColumnSql[dbDriver.clientType()], [
                tnPath,
                'nc_order'
            ]).toQuery();
            const realDbDriver = await _NcConnectionMgrv2.default.get(new _models.Source(_extends({}, source, {
                upgraderMode: false
            })));
            await realDbDriver.raw(query);
            await model.getColumns(context, ncMeta);
            const decimalOrderCol = model.columns.find((c)=>c.uidt === 'Decimal' && c.system && c.column_name.startsWith('nc_order'));
            if (decimalOrderCol) {
                await _models.Column.delete(context, decimalOrderCol.id, ncMeta);
            }
            await ncMeta.runUpgraderQueries();
            this.processedModelsCount++;
        } catch (error) {
            this.log(`Error processing model ${modelData.id}:`, error.message);
            throw error;
        }
    }
    constructor(orderColumnMigration){
        this.orderColumnMigration = orderColumnMigration;
        this.processingModels = [
            {
                fk_model_id: 'placeholder',
                processing: true
            }
        ];
        this.processedModelsCount = 0;
        this.cache = new _cache.default(1000);
        this.log = (...msgs)=>{
            console.log('[nc_job_007_recover-order-column]: ', ...msgs);
        };
    }
};
RecoverOrderColumnMigration = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _nc_job_005_order_column.OrderColumnMigration === "undefined" ? Object : _nc_job_005_order_column.OrderColumnMigration
    ])
], RecoverOrderColumnMigration);
